export default "__VITE_ASSET__DIGCd0gD__"